import {
  DatePipe,
  KeyValuePipe,
  NgClass,
  NgFor,
  NgIf,
  TitleCasePipe,
} from '@angular/common';
import { Component, Input, SimpleChanges } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { PaginatorModule } from 'primeng/paginator';

@Component({
  selector: 'app-news-category',
  standalone: true,
  imports: [NgFor, NgIf, PaginatorModule, DatePipe, RouterLink, KeyValuePipe],
  templateUrl: './news-category.component.html',
  styleUrl: './news-category.component.scss',
})
export class NewsCategoryComponent {
  @Input() data:
    | {
      [key: string]: any[];
    }
    | undefined;
  @Input() showNews: boolean = false;
  @Input() showAllButton: boolean = false;
  @Input() databaseId: string = ''; // Database ID to pass in navigation
  filePath = 'https://adminbackend.chemrobotics.com/uploads/news_images/';

  constructor(private router: Router) { }

  ngOnInit(): void {
    console.log('📰 News Category Component Initialized');
    console.log('  - data:', this.data);
    console.log('  - showNews:', this.showNews);
    console.log('  - Data keys:', this.data ? Object.keys(this.data) : 'undefined');
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data']) {
      console.log('📰 News Category Data Changed:');
      console.log('  - Previous:', changes['data'].previousValue);
      console.log('  - Current:', changes['data'].currentValue);
      console.log('  - Keys:', this.data ? Object.keys(this.data) : 'undefined');
      console.log('  - Is Empty?:', this.data ? Object.keys(this.data).length === 0 : true);
    }
    if (changes['showNews']) {
      console.log('📰 showNews Changed:', changes['showNews'].currentValue);
    }
  }

  goToNewsDetail(_id: any) {
    this.router.navigate(['/discovery-updates', _id]);
  }

  goToCategoryPage(categoryId: string) {
    // Navigate with database ID as query parameter
    this.router.navigate(['/discovery-category', categoryId], {
      queryParams: { databaseId: this.databaseId }
    });
  }
}
